module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-15.cf23d909.png";